import { ValuesSchemaType, OperatorType } from "../schemas";

type Params = {
  title: string;
  activeValues: ValuesSchemaType;
  operatorValues: OperatorType;
};

export function useFilterIndicator({
  title,
  activeValues,
  operatorValues,
}: Params) {
  const hasMultipleValues = activeValues.length >= 2;

  const displayText = hasMultipleValues
    ? `${activeValues.length} ${title}`
    : activeValues.map((value) => value.label).join(", ");

  const activeOperator = operatorValues.values.find((op) => op.checked);

  return { hasMultipleValues, displayText, activeOperator };
}
